module.exports = __webpack_public_path__ + "img/popup-bg.d480f1d.svg";